module.exports = __webpack_public_path__ + "img/Flag_of_France (2).f64380d7.svg";